module.exports = __webpack_public_path__ + "static/media/MoreWaysToEarnCanteen.de829cdd.png";